module.exports = __webpack_public_path__ + "static/img/cns-3.7d0504b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cns-3.jpg
// module id = 459f
// module chunks = 0